export const TentIcon = ({ width = '24', height = '24', fill = '#0F2664' }) => {
  return (
    <div className="feature">
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M13.9102 10.54H13.1755V11.2747H13.9102V10.54Z" fill={fill} />
        <path
          d="M22.0028 20.434V20.434L12.4296 4.6381L13.2938 3.21221L12.6654 2.83139L12 3.9293L11.3346 2.8313L10.7062 3.21216L11.5704 4.63805L1.9972 20.434H0V21.1687H24V20.434H22.0028ZM12 5.34689L13.9304 8.532H10.0697L12 5.34689ZM8.73384 20.434L12 15.0449L15.2662 20.434H8.73384ZM15.551 19.4865L12.6522 14.7034H15.551V19.4865ZM16.2857 20.434V13.9687H11.7931L7.87472 20.434H2.85628L8.40731 11.2748H12.4408V10.5402H8.85258L9.62442 9.26672H14.3757L21.1438 20.4341H16.2857V20.434Z"
          fill={fill}
        />
      </svg>
    </div>
  );
};
